import {
  ALL_STAKEHOLDER_TYPES,
  ALERT_DELIVERY_TYPE_ALL,
  ALERT_DELIVERY_TYPE_EMAIL,
  ALERT_DELIVERY_TYPE_SMS,
  ALERT_DELIVERY_TYPE_VOICE,
  RESPONDER_STAKEHOLDER_TYPES,
  SEND_ALERT_DEFAULT_MESSAGE,
  STAKEHOLDER_GROUP_ALL,
  STAKEHOLDER_GROUP_ALL_RESPONDERS,
} from "./model";

export type SendAlertFormValues = {
  stakeholderType: string;
  country: string;
  state: string;
  county: string;
  title: string;
  message: string;
  deliveryType: string;
};

export type SendAlertFormErrors = Partial<Record<keyof SendAlertFormValues, string>>;

export const SEND_ALERT_FORM_DEFAULTS: SendAlertFormValues = {
  stakeholderType: "",
  country: "United States",
  state: "",
  county: "",
  title: "",
  message: SEND_ALERT_DEFAULT_MESSAGE,
  deliveryType: "",
};

const REQUIRED = "Required";

export function validateSendAlertForm(form: SendAlertFormValues): SendAlertFormErrors {
  const e: SendAlertFormErrors = {};
  if (!form.stakeholderType.trim()) e.stakeholderType = REQUIRED;
  if (!form.country.trim()) e.country = REQUIRED;
  if (!form.state.trim()) e.state = REQUIRED;
  if (!form.county.trim()) e.county = REQUIRED;
  if (!form.message.trim()) e.message = REQUIRED;
  if (!form.deliveryType.trim()) e.deliveryType = REQUIRED;
  return e;
}

export function getStakeholderTypesForPayload(selected: string): string[] {
  if (selected === STAKEHOLDER_GROUP_ALL) return [...ALL_STAKEHOLDER_TYPES];
  if (selected === STAKEHOLDER_GROUP_ALL_RESPONDERS) return [...RESPONDER_STAKEHOLDER_TYPES];
  return [selected];
}

export type BuxusSendAlertDto = {
  token: string;
  stakeholderTypes: string[];
  counties: string[];
  /** Used to resolve CRM Locations for jurisdiction/region targeting. */
  country?: string | null;
  title: string | null;
  message: string;
  deliveryType: string;
  senderEmailAddress?: string | null;
};

export function buildBuxusSendAlertDto(
  form: SendAlertFormValues,
  token: string,
  senderEmail: string | null | undefined,
): BuxusSendAlertDto {
  return {
    token,
    stakeholderTypes: getStakeholderTypesForPayload(form.stakeholderType),
    counties: [`${form.state} - ${form.county}`],
    country: form.country.trim() || null,
    title: form.title.trim() ? form.title.trim() : null,
    message: form.message.trim(),
    deliveryType: form.deliveryType,
    senderEmailAddress: senderEmail?.trim() || null,
  };
}

export const DELIVERY_OPTIONS: { label: string; value: string }[] = [
  { label: "All At Once", value: ALERT_DELIVERY_TYPE_ALL },
  { label: "Email Only", value: ALERT_DELIVERY_TYPE_EMAIL },
  { label: "SMS Only", value: ALERT_DELIVERY_TYPE_SMS },
  { label: "Voice Only", value: ALERT_DELIVERY_TYPE_VOICE },
];

export const COUNTRY_OPTIONS: { label: string; value: string }[] = [
  { label: "United States", value: "United States" },
  { label: "Canada", value: "Canada" },
];

export type BuxusPreviewAlertOutput = {
  contactCount?: number;
  smsCount?: number;
  emailCount?: number;
  voiceCount?: number;
  stateCounties?: string[];
};

/** `BuxusJobOutput` from POST `/api/buxus/send-alert` — ABP JSON uses camelCase (`success`, `jobId`). */
export type BuxusSendAlertOutput = {
  success?: boolean;
  jobId?: string;
};
